export function trigger(elem: HTMLElement, eventName: string, eventInitDict?:any ) {
    let event = null;
    try {
        event = new CustomEvent(eventName, eventInitDict);
    }
    catch (error) {
        event = document.createEvent("Event");
        let doesnt_bubble = false;
        let isnt_cancelable = false;
        event.initEvent(eventName, doesnt_bubble, isnt_cancelable);
    }
    elem.dispatchEvent(event);
}

export function hide(elem: HTMLElement) {
    elem.classList.add('gs-hide');
}

export function show(elem: HTMLElement) {
    elem.classList.remove('gs-hide');
}